import React, { useState, useContext, useEffect } from "react";
import { makeStyles, Grid, Card, IconButton, Tooltip } from "@material-ui/core";
import { LangContext } from "../../../Context/Langcontext";
import { UserContext } from "../../../Context/UserContext";
import { FaLayerGroup, FaSort } from "react-icons/fa";
import TableData from "../../Item/TableData";
import { ServiceContext } from "../../../Context/ServiceContext";
import useReactRouter from "use-react-router";
import FilterUser from "../../Item/filterUser";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    height: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
  },
  cardstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
}));

const Limitusage = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const userContext = useContext(UserContext);
  const userlist = userContext.data;
  const [userData, setUserData] = useState(userlist);
  const serviceContext = useContext(ServiceContext);

  const { history } = useReactRouter();

  const columns = [
    {
      title: lang.No,
      field: "no",
      width: "10px",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: `${lang.Name} - ${lang.Lastname}`,
      field: "name",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Organization,
      field: "organization",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Type,
      field: "type",
      sorting: false,
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Credits,
      field: "balance",
      sorting: false,
      headerStyle: {
        textAlign: "right",
      },
      cellStyle: {
        textAlign: "right",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Usage,
      field: "usage",
      sorting: false,
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "right",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title:
        langContext.lang.locale === "th"
          ? "ปริมาณมากผิดปกติ"
          : "Over quota requests",
      field: "error",
      sorting: false,
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "right",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    { title: lang.Setting, sorting: false, field: "setting" },
  ];

  const showOrganization = (org) => {
    if (org.organization) {
      return org.organization;
    } else if (org.mea) {
      return "MEA";
    } else {
      return "-";
    }
  };

  const filterOver = (uid) => {
    let findUser = userContext.notification.filter((rs) => {
      return rs.user_id === uid;
    });

    if (findUser.length) {
      let findMessage = findUser.filter((r) => {
        return r.message === "บัญชีของคุณมีการใช้งาน API มากกว่าปกติ";
      });
      return findMessage.length.toLocaleString();
    } else {
      return 0;
    }
  };

  const getBalance = (uid) => {
    let total = 0;
    userContext.payment
      .filter((u) => u.user_id === uid)
      .map((d) => (total = total + d.total));

    const user = serviceContext.sum.find((rs) => {
      return rs._id !== undefined ? rs._id.user_id === uid : "";
    });
    const balance =
      user !== undefined
        ? Number(Number(total) - Number(user.sum_net))
        : Number(total);
    return balance
      .toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      .toLocaleString();
  };

  const Rows = userData
    .filter((res) => {
      return res.role !== "admin" && res.role !== "root";
    })
    .map((rs, index) => {
      let num = serviceContext.sum.find((res) => {
        return res._id.user_id === rs._id;
      });

      return {
        no: index + 1,
        name: `${rs.first_name} ${rs.last_name}`,
        organization: showOrganization(rs),
        type: `${rs.role.split("_").join(" ").charAt(0).toUpperCase()}${rs.role
          .split("_")
          .join(" ")
          .slice(1)}`,
        balance: getBalance(rs._id),
        usage: num ? num.sum_request.toLocaleString() : 0,
        error: filterOver(rs._id),
        setting: (
          <Tooltip title={lang.DefineService} placement="top">
            <IconButton
              size="small"
              onClick={() => {
                history.push(`/app/limit/setting/${rs._id}/data`);
              }}
            >
              <FaLayerGroup size={16} />
            </IconButton>
          </Tooltip>
        ),
      };
    });

  useEffect(() => {
    setUserData(userlist);
  }, [userlist]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-start",
          }}
        >
          <Card className={classes.cardstyle}>
            <div style={{ margin: "1rem" }}>
              <Grid container spacing={0}>
                <Grid item md={5} sm={12} xs={12}>
                  <div style={{ margin: "1rem 1rem 0rem 1rem" }}>
                    <FilterUser setUserData={setUserData} />
                  </div>
                </Grid>
                <Grid
                  item
                  md={7}
                  sm={12}
                  xs={12}
                  className={classes.grid}
                ></Grid>
              </Grid>
            </div>
            <TableData
              columns={columns}
              data={Rows}
              Iconsort={React.forwardRef((props, ref) => (
                <FaSort {...props} ref={ref} />
              ))}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Limitusage;
